export const homeSv = `
<div class="main2">
    <div class="box">
        <div class="cnt langs">
            <table width="500" border="0">
                <tbody>
                    <tr>
                        <td colspan="3"><strong>Select Language</strong></td>
                    </tr>
                    <tr>
                        <td><a><img src="./app/static/images/sv.png" lang="sv" width="96" height="64"></a></td>
                        <td><a><img src="./app/static/images/zh.png" lang="zh" width="96" height="64"></a></td>
                        <td><a><img src="./app/static/images/en.png" lang="en" width="96" height="64"></a></td>
                    </tr>
                    <tr>
                        <td>Svenska</td>
                        <td>中文</td>
                        <td>English</td>
                    </tr>
                </tbody>
            </table>
            <p></p>
            <h1>Visumansökan till Kina</h1>
            <p>Fyll i visumansökan online och skicka därefter in de ytterligare dokument som krävs för visumansökan.</p>
            <p><a href="#/license" class="btn btn1">Starta en ny visumansökan</a></p>
            <p><a href="#/continue" class="btn btn1">Fortsätt på en sparad</a></p>
        </div>
        <div class="btm"></div>
    </div>
</div>
`